import { render, staticRenderFns } from "./PromotionsComponent.vue?vue&type=template&id=20e8e780&scoped=true&"
import script from "./PromotionsComponent.vue?vue&type=script&lang=js&"
export * from "./PromotionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsComponent.vue?vue&type=style&index=0&id=20e8e780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e8e780",
  null
  
)

export default component.exports